export default __webpack_public_path__ + "static/media/banner-mais-premiavel-desktop.55f39706.png";